import { render, staticRenderFns } from "./CustomerTempCreditEdit.vue?vue&type=template&id=02f80b63"
import script from "./CustomerTempCreditEdit.vue?vue&type=script&lang=js"
export * from "./CustomerTempCreditEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports